import { useCallback, useMemo } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, Button, Card, Modal, Stack, Transition } from 'ui';
import { useDebouncedValue } from 'ui/Hooks';
import { IconArrowLeft } from 'ui/Icons';

import { OnboardingModal } from '../OnboardingModal';
import { CausesNearYou } from './CausesNearYou/CausesNearYou';
import { CausesSearchInput } from './CausesSearchInput';
import { CauseSearchResultView } from './CausesSearchResults';
import { PopularCauses } from './PopularCauses';

const CausesModalFooter = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const causeSearch = useMemo(() => searchParams.get('search') ?? '', [searchParams]);

  const handleSkip = useCallback(() => {
    navigate('/home');
  }, [navigate]);

  return (
    <Modal.AffixedFooter>
      <Transition
        mounted={causeSearch !== ''}
        transition="slide-right"
        timingFunction="ease"
        enterDelay={25}
      >
        {(styles) => (
          <Box style={styles}>
            <Button
              variant="transparent"
              onClick={() => setSearchParams({ search: '' })}
              leftSection={<IconArrowLeft />}
            >
              Back
            </Button>
          </Box>
        )}
      </Transition>
      <Transition
        mounted={causeSearch === ''}
        transition="slide-right"
        timingFunction="ease"
        enterDelay={25}
      >
        {(styles) => (
          <Box style={styles}>
            <Button variant="gray" fullWidth onClick={handleSkip}>
              Skip For Now
            </Button>
          </Box>
        )}
      </Transition>
    </Modal.AffixedFooter>
  );
};

const CausesContent = () => {
  const [searchParams] = useSearchParams();
  const causeSearch = useMemo(() => searchParams.get('search') ?? '', [searchParams]);
  const [debouncedCauseSearch] = useDebouncedValue(causeSearch, 250);

  return (
    <Card bg="white" pt="xl">
      <Stack gap="lg">
        <CausesSearchInput />
        <Transition
          mounted={debouncedCauseSearch !== ''}
          timingFunction="ease"
          transition="slide-right"
        >
          {(styles) => (
            <Box style={styles}>
              <CauseSearchResultView causeSearch={debouncedCauseSearch} />
            </Box>
          )}
        </Transition>
        <Transition
          mounted={debouncedCauseSearch === ''}
          timingFunction="ease"
          transition="slide-right"
        >
          {(styles) => (
            <Stack style={styles} gap="lg">
              <CausesNearYou />
              <PopularCauses />
            </Stack>
          )}
        </Transition>
      </Stack>
    </Card>
  );
};

const Causes = () => {
  return (
    <OnboardingModal
      title="Find and follow the orgs you care about."
      description="Search for a school or nonprofit and click Follow."
    >
      <CausesContent />
      <CausesModalFooter />
    </OnboardingModal>
  );
};
export { Causes };
